import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";
import { useT } from "@/i18n/LanguageProvider";

const CONTENT = {
  fr: {
    eyebrow: "Informations légales",
    title: "Mentions légales",
    sections: [
      {
        h: "Éditeur et responsable de publication",
        body: (
          <>
            <p>
              Le site HorsIndex est édité par{" "}
              <Link to="/simon-marie" className="text-[#181A1D] underline-link">Simon Marie</Link>.
            </p>
            <p className="mt-4">
              Responsable de la publication : Simon Marie<br />
              Contact professionnel :{" "}
              <a href="mailto:horsindex@gmail.com" className="text-[#181A1D] underline-link">
                horsindex@gmail.com
              </a>
              <br />
              Téléphone professionnel :{" "}
              <a href="tel:+33608033203" className="text-[#181A1D] underline-link">
                06 08 03 32 03
              </a>
            </p>
          </>
        ),
      },
      {
        h: "Nature du site",
        body: (
          <p>
            HorsIndex est actuellement un site de présentation et de ressources
            consacré à l'exposition numérique. Aucune prestation commerciale
            n'est proposée via ce site. Les messages adressés depuis le
            formulaire de contact constituent de simples prises de contact et
            n'engagent aucune relation commerciale.
          </p>
        ),
      },
      {
        h: "Hébergement",
        body: (
          <p>
            Le site est hébergé par Netlify, Inc., 512 2nd Street, Suite 200,
            San Francisco, CA 94107 (États-Unis) :{" "}
            <a
              href="https://www.netlify.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#181A1D] underline-link"
            >
              www.netlify.com
            </a>.
          </p>
        ),
      },
      {
        h: "Contact",
        body: (
          <p>
            Par e-mail à{" "}
            <a href="mailto:horsindex@gmail.com" className="text-[#181A1D] underline-link">horsindex@gmail.com</a>{" "}
            ou via le{" "}
            <Link to="/contact" className="text-[#181A1D] underline-link">formulaire de contact</Link>.
          </p>
        ),
      },
      {
        h: "Protection des données",
        body: (
          <p>
            Les données transmises via le formulaire du site sont utilisées
            uniquement pour traiter la demande de l'utilisateur et assurer les
            échanges nécessaires. Elles ne sont pas vendues. Les personnes
            concernées peuvent exercer leurs droits relatifs aux données
            personnelles en écrivant à{" "}
            <a href="mailto:horsindex@gmail.com" className="text-[#181A1D] underline-link">horsindex@gmail.com</a>.
            Les informations complémentaires figurent dans la{" "}
            <Link to="/politique-confidentialite" className="text-[#181A1D] underline-link">
              politique de confidentialité
            </Link>.
          </p>
        ),
      },
      {
        h: "Propriété intellectuelle",
        body: (
          <>
            <p>
              HorsIndex est une marque française enregistrée auprès de l'INPI
              sous le n° 5261808.
            </p>
            <p className="mt-4">
              Les textes, l'identité visuelle, le logo, la structure et la mise en page
              du site sont protégés par les législations applicables relatives à la
              propriété intellectuelle. Toute reproduction ou diffusion,
              totale ou partielle, sans autorisation préalable écrite est interdite.
            </p>
          </>
        ),
      },
    ],
  },
  en: {
    eyebrow: "Legal information",
    title: "Legal notice",
    sections: [
      {
        h: "Publisher and editorial lead",
        body: (
          <>
            <p>The HorsIndex website is published by Simon Marie.</p>
            <p className="mt-4">
              Editorial lead: Simon Marie<br />
              Professional contact:{" "}
              <a href="mailto:horsindex@gmail.com" className="text-[#181A1D] underline-link">
                horsindex@gmail.com
              </a>
              <br />
              Professional phone:{" "}
              <a href="tel:+33608033203" className="text-[#181A1D] underline-link">
                +33 6 08 03 32 03
              </a>
            </p>
          </>
        ),
      },
      {
        h: "Nature of the website",
        body: (
          <p>
            HorsIndex is currently a presentation and resource website dedicated
            to digital exposure. No commercial service is offered through this
            website. Messages sent via the contact form are simple contact
            requests and do not create any commercial relationship.
          </p>
        ),
      },
      {
        h: "Hosting",
        body: (
          <p>
            The site is hosted by Netlify, Inc., 512 2nd Street, Suite 200,
            San Francisco, CA 94107 (United States):{" "}
            <a
              href="https://www.netlify.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#181A1D] underline-link"
            >
              www.netlify.com
            </a>.
          </p>
        ),
      },
      {
        h: "Contact",
        body: (
          <p>
            By e-mail at{" "}
            <a href="mailto:horsindex@gmail.com" className="text-[#181A1D] underline-link">horsindex@gmail.com</a>{" "}
            or via the{" "}
            <Link to="/contact" className="text-[#181A1D] underline-link">contact form</Link>.
          </p>
        ),
      },
      {
        h: "Data protection",
        body: (
          <p>
            Data submitted through the website form is used solely to handle
            the user's request and the necessary exchanges. It is not sold.
            Individuals may exercise their data protection rights by writing
            to{" "}
            <a href="mailto:horsindex@gmail.com" className="text-[#181A1D] underline-link">horsindex@gmail.com</a>.
            Further information is available in the{" "}
            <Link to="/politique-confidentialite" className="text-[#181A1D] underline-link">privacy policy</Link>.
          </p>
        ),
      },
      {
        h: "Intellectual property",
        body: (
          <>
            <p>
              HorsIndex is a French trademark registered with the INPI under
              no. 5261808.
            </p>
            <p className="mt-4">
              The texts, visual identity, logo, structure and layout of the site are
              protected by applicable intellectual property laws. Any
              reproduction or distribution, in whole or in part, without prior written
              authorisation is prohibited.
            </p>
          </>
        ),
      },
    ],
  },
};

export default function MentionsLegales() {
  const { lang, t } = useT();
  const c = CONTENT[lang] || CONTENT.fr;

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div data-testid="page-mentions-legales" className="bg-[#FAF9F7] text-[#181A1D] min-h-screen">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 lg:px-10 pt-32 lg:pt-40 pb-24">
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#666A70] hover:text-[#181A1D] mb-12 transition-colors"
        >
          <ArrowLeft size={14} strokeWidth={1.5} /> {t("common.back")}
        </Link>

        <p className="label-eyebrow mb-6">{c.eyebrow}</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#181A1D] tracking-tight leading-[1.05] font-normal mb-7 text-balance">
          {c.title}
        </h1>
        <div className="h1-marker mb-12" />

        <div className="space-y-12 font-normal text-[#52565C] leading-relaxed">
          {c.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-serif text-2xl text-[#181A1D] mb-4">{s.h}</h2>
              {s.body}
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
